// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRemoteLogMessageSender } from "@lib/logging/IRemoteLogMessageSender";
import { LogLevel } from "@lib/logging/LogLevel";
import { LogMessage } from "@lib/logging/LogMessage";
import { IMessageSender } from "@lib/messaging/IMessageSender";
import { NetworkSource } from "@lib/messaging/NetworkSource";

/**
 * Provides methods for sending log messages to a remote logger.
 */
export class RemoteLogMessageSender implements IRemoteLogMessageSender
{
  messageSender: IMessageSender;
  target: NetworkSource;

  constructor(messageSender: IMessageSender, target: NetworkSource)
  {
    this.messageSender = messageSender;
    this.target = target;
  }

  sendLogMessage(logLevel: LogLevel, format: string, args: any[]): void
  {
    const logMessage: LogMessage = {
      message: this.formatMessage(format, args),
      logLevel: this.getLogLevelName(logLevel)
    };

    this.messageSender.sendMessage(this.target, logMessage);
  }

  private formatMessage(format: string, args: any[]): string
  {
    let argIndex = 0;
    return format.replace(/%[os]/ig, (match) =>
    {
      const id = match[1].toLowerCase();
      if (id === "s" || id === "o")
        return String(args[argIndex++]);
      else
        return match;
    });
  }

  private getLogLevelName(logLevel: LogLevel): string
  {
    switch (logLevel)
    {
      case LogLevel.All:
        return "trace";
      case LogLevel.Debug:
        return "debug";
      case LogLevel.Information:
        return "info";
      case LogLevel.Warning:
        return "warn";
      case LogLevel.Error:
        return "error";
      default:
        throw new Error("Invalid log level specified.");
    }
  }
}